import { Card } from "./card";
import { Typography, Stack, Skeleton, LinearProgress, useTheme } from "@mui/material";

function InfoStat({ title, value, unit, subtitle, color, isLoading, fontSize, tooltip, ...props }) {
  return (
    <Card
      title={title}
      tooltip={tooltip}
      headerMargin={1}
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...props.sx,
      }}
    >
      <Stack direction="column" alignItems="center" justifyContent="center" sx={{ height: 80 }}>
        <Stack direction="row">
          <Typography fontWeight="700" fontSize={fontSize || 50} color={color} lineHeight="50px" height={50}>
            {value != null ? value : "N/A"}
          </Typography>
          <Typography
            fontWeight="700"
            fontSize={30}
            lineHeight="25px"
            sx={{ mb: "5px", ml: "3px" }}
            color={"#999"}
            alignSelf="flex-end"
          >
            {unit}
          </Typography>
        </Stack>
        <Typography fontWeight="500" fontSize={14} lineHeight="1em" color={"#999"} alignSelf="center">
          {subtitle}
        </Typography>
      </Stack>
    </Card>
  );
}

export default InfoStat;
